import React from "react"
import MaskedInput from "react-text-mask"

export const PhoneInputMask = props => {
    const { inputRef, ...other } = props
    return (
        <MaskedInput
            {...other}
            ref={inputRef}
            mask={["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}
            showMask={false}
            guide={false}
        />
    )
}



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/components/PhoneNumberInput.jsx